module.exports = __webpack_public_path__ + "static/media/AMXCondensedBlue.27944827.svg";